import React from 'react';
import SectionWrapper from '../layout/SectionWrapper';
import ConferenceItem from './ConferenceItem';

/**
 * Specialized component for rendering conference presentations
 * Handles conference-specific layout and alternating image positioning
 */
const ConferencesList = ({ 
  conferences, 
  images = [], 
  title = 'Conferences',
  titleTag = 'h4'
}) => {
  if (!conferences || !conferences.length) return null;

  return (
    <SectionWrapper title={title} titleTag={titleTag}>
      {conferences.map((conference, index) => (
        <ConferenceItem 
          key={conference.id || index}
          conference={conference}
          image={images[index]}
          imagePosition={index % 2 === 0 ? 'right' : 'left'}
        />
      ))}
    </SectionWrapper>
  );
};

export default ConferencesList;